export const serviceConstants = {
  OKTA_TOKEN_KEY: 'okta-token-storage',
  CS_PAGERDUTY_TOKEN: 'cs-pagerDuty-token'
};

export const errorConstants = {
  SERVER_ERROR: 'Failed to fetch data. Please try again.'
};

export const OTHER_API_URL = 'https://www.exapmple.com/some-other-api/error';
